import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.542 13.12a1.5 1.5 0 0 1 1.339 1.338l.008.153v2.945a4.444 4.444 0 0 1-4.216 4.438L6.444 22A4.445 4.445 0 0 1 2 17.556l.006-.229a4.445 4.445 0 0 1 4.21-4.21l.228-.006H9.39zM6.444 14.61a2.944 2.944 0 1 0 2.945 2.945V14.61zM17.556 13.111l.228.006a4.445 4.445 0 0 1 4.21 4.21l.006.229A4.445 4.445 0 0 1 17.556 22l-.229-.006a4.444 4.444 0 0 1-4.216-4.438V14.61l.008-.153a1.5 1.5 0 0 1 1.339-1.339l.153-.008zm-2.945 1.5v2.945a2.945 2.945 0 1 0 2.945-2.945zM6.673 2.006a4.444 4.444 0 0 1 4.216 4.438V9.39l-.008.153a1.5 1.5 0 0 1-1.339 1.339l-.153.008H6.444l-.228-.006a4.445 4.445 0 0 1-4.21-4.21L2 6.444A4.445 4.445 0 0 1 6.444 2zM6.444 3.5a2.944 2.944 0 0 0 0 5.889H9.39V6.444A2.944 2.944 0 0 0 6.444 3.5M17.556 2A4.445 4.445 0 0 1 22 6.444l-.006.229a4.445 4.445 0 0 1-4.21 4.21l-.228.006H14.61l-.153-.008a1.5 1.5 0 0 1-1.339-1.339l-.008-.153V6.444a4.444 4.444 0 0 1 4.216-4.438zm0 1.5a2.944 2.944 0 0 0-2.945 2.944V9.39h2.945a2.944 2.944 0 0 0 0-5.889",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }